import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateSaleOrderPaymentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import SaleOrderPaymentService from "../../Controller/SaleOrderPaymentController";
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
function CreateSaleOrderPayment({ modalInstance, currentSaleOrderPayment, onClose, onSuccess, SaleOrderID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({
        SaleOrderID: SaleOrderID, dt_Created: '', vc_Description: ""
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [SaleOrderPaymentMethodList, setSaleOrderPaymentMethod] = useState([]);
    const fetchSaleOrderPayment = async () => {
        try {

            const data = await SaleOrderPaymentService.GetAllPaymentMethod();
            setSaleOrderPaymentMethod(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {
        fetchSaleOrderPayment();
        if (currentSaleOrderPayment) {

            const formattedDate = new Date(currentSaleOrderPayment.dt_PaymentDate).toISOString().split('T')[0];
            setFormData({
                ...formData,
                dt_PaymentDate: formattedDate,
                mon_Amount: currentSaleOrderPayment.mon_Amount,
                snt_PaymentType: currentSaleOrderPayment.snt_PaymentType,
                Reference: currentSaleOrderPayment.Reference,
                FK_SalesOrder_ID: currentSaleOrderPayment.SaleOrderID,
            });
        } else {
            setFormData({
                ...formData,
                FK_SalesOrder_ID: SaleOrderID, dt_PaymentDate: '', mon_Amount: "", snt_PaymentType: 0,
                Reference: ""
            });
        }
    }, [currentSaleOrderPayment]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        if (currentSaleOrderPayment) {
            formData.ID = currentSaleOrderPayment.PK_SalesOrderPayment_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_SalesOrder_ID = SaleOrderID;
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();

        }, () => {
            onSuccess();

        });
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentSaleOrderPayment ? "Edit Payment" : "Add Payment"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "10px", marginTop: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>


                                                <tr>
                                                    <td style={{width:"13%"}}> <label htmlFor="dt_PaymentDate" style={{ float: "right" }}>Date <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="date" className="form-control" name="dt_PaymentDate" value={formData.dt_PaymentDate} onChange={handleFieldChange} />
                                                        {errors.dt_PaymentDate && <div style={{ color: 'red' }}>{errors.dt_PaymentDate}</div>}
                                                    </td>
                                                    <td style={{width:"13%"}}> <label htmlFor="mon_Amount" style={{ float: "right" }}>Amount <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="text" className="form-control" name="mon_Amount" value={formData.mon_Amount} onChange={handleFieldChange} />
                                                        {errors.mon_Amount && <div style={{ color: 'red' }}>{errors.mon_Amount}</div>}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td> <label htmlFor="snt_PaymentType" style={{ float: "right" }}>Payment Type <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td>
                                                        <select name="snt_PaymentType" className='form-control' value={formData.snt_PaymentType} onChange={handleFieldChange}>
                                                            <option value="0"> Select Type</option>
                                                            {SaleOrderPaymentMethodList.map((type) => (
                                                                <option key={type.PK_PaymentMethod_ID} value={type.PK_PaymentMethod_ID}>
                                                                    {type.vc_Name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.snt_PaymentType && <div style={{ color: 'red' }}>{errors.snt_PaymentType}</div>}
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td> <label htmlFor="Reference" style={{ float: "right" }}>Reference <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td colSpan={3}>
                                                        <input type="text" className="form-control" name="Reference" value={formData.Reference} onChange={handleFieldChange} />
                                                        {errors.Reference && <div style={{ color: 'red' }}>{errors.Reference}</div>}
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  {currentSaleOrderPayment ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                       <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSaleOrderPayment;
